
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface UserCreditsFormProps {
  selectedUser: string;
  creditsToAdd: number;
  onCreditsChange: (credits: number) => void;
  onAddCredits: () => void;
  disabled: boolean;
}

export function UserCreditsForm({ 
  selectedUser, 
  creditsToAdd, 
  onCreditsChange, 
  onAddCredits, 
  disabled 
}: UserCreditsFormProps) {
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="selected-user">Επιλεγμένος Χρήστης</Label>
        <Input 
          id="selected-user" 
          value={selectedUser} 
          readOnly 
          className="mt-1"
        />
      </div>
      <div>
        <Label htmlFor="credits-to-add">Credits για προσθήκη</Label>
        <Input 
          id="credits-to-add" 
          type="number" 
          min="1"
          value={creditsToAdd}
          onChange={(e) => onCreditsChange(parseInt(e.target.value) || 0)}
          className="mt-1"
        />
      </div>
      <Button 
        className="w-full" 
        onClick={onAddCredits}
        disabled={disabled}
      >
        Προσθήκη Credits
      </Button>
    </div>
  );
}
